/* Rättningar för headerns direktsökning. Beskrivning i snippets/NV-SEARCH-FIX.liquid. */
(function () {
  if (window.NVSearchFix) return;
  window.NVSearchFix = true;

  var ERROR_TEXT = 'Kunde inte hämta förslag. Tryck Enter för att söka.';
  var TIMEOUT = 8000;
  // Samma tangenter som _search i superstore.js hoppar över
  var SKIP = ['Alt', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Capslock', 'Control', 'Escape', 'Meta', 'Shift', 'Tab', 'Enter'];

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(sel) : el.msMatchesSelector(sel)) return el;
      el = el.parentNode;
    }
    return null;
  }

  // Bara fält i en sökning med flydown (headern), inte sökresultatsidans eget formulär
  function searchInput(el) {
    if (!el || el.nodeType !== 1 || !el.hasAttribute('data-live-search-input')) return null;
    var box = closest(el, '[data-live-search]');
    if (!box || !box.querySelector('[data-live-search-flydown]')) return null;
    return el;
  }
  function boxOf(input) { return closest(input, '[data-live-search]'); }
  function allInputs() {
    var out = [];
    var list = document.querySelectorAll('[data-live-search-input]');
    for (var i = 0; i < list.length; i++) if (searchInput(list[i])) out.push(list[i]);
    return out;
  }

  function syncValueClass(input) {
    var box = boxOf(input);
    if (!box) return;
    if (input.value.length) box.classList.add('nv-ls-has-value');
    else box.classList.remove('nv-ls-has-value');
  }

  // En keyup som temats _search tar emot (via jQuery .on på fältet)
  function fireKeyup(input) {
    var ev;
    try {
      ev = new Event('keyup', { bubbles: true, cancelable: true });
    } catch (err) {
      ev = document.createEvent('Event');
      ev.initEvent('keyup', true, true);
    }
    ev._nvSynthetic = true;
    input.dispatchEvent(ev);
  }

  /* ---------- 3. Misslyckad hämtning ---------- */
  function showError(input) {
    var box = boxOf(input);
    if (!box || !input.value.length) return;
    var ph = box.querySelector('[data-live-search-placeholder]');
    var results = box.querySelector('[data-live-search-results]');
    var btn = box.querySelector('[data-live-search-submit]');
    if (!ph || !ph.classList.contains('visible')) return;
    ph.classList.remove('visible');
    if (results) {
      results.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'nv-ls-error';
      p.setAttribute('role', 'status');
      p.setAttribute('data-nv-ls-error', '');
      p.appendChild(document.createTextNode(ERROR_TEXT));
      results.appendChild(p);
      results.classList.add('visible');
    }
    var fly = box.querySelector('[data-live-search-flydown]');
    if (fly) fly.style.setProperty('--open-height', 'auto');
    if (btn) {
      btn.classList.remove('search-icon--processing');
      btn.removeAttribute('disabled');
    }
  }

  function armTimer(input) {
    clearTimeout(input._nvLsTimer);
    if (!input.value.length) return;
    input._nvLsTimer = setTimeout(function () { showError(input); }, TIMEOUT);
  }

  // fetch-felet kastas vidare i temat och blir ett ohanterat fel. Syns
  // platshållarna fortfarande då har förslagen inte kommit fram.
  window.addEventListener('unhandledrejection', function () {
    setTimeout(function () {
      var inputs = allInputs();
      for (var i = 0; i < inputs.length; i++) {
        // Temat väntar 250 ms innan det söker; ett fel före det hör inte hit
        if (inputs[i]._nvLsStarted && Date.now() - inputs[i]._nvLsStarted > 250) showError(inputs[i]);
      }
    }, 0);
  });

  /* ---------- keyup: starta vakten (riktiga och egna) ---------- */
  var lastKeyup = 0;
  document.addEventListener('keyup', function (e) {
    var input = searchInput(e.target);
    if (!input) return;
    if (!e._nvSynthetic) lastKeyup = Date.now();
    if (e.key && SKIP.indexOf(e.key) !== -1) return;
    syncValueClass(input);
    input._nvLsStarted = input.value.length ? Date.now() : 0;
    armTimer(input);
  }, true);

  /* ---------- 2. Inklistring och annan inmatning utan keyup ---------- */
  var PASTE_TYPES = ['insertFromPaste', 'insertFromDrop', 'insertReplacementText', 'insertFromYank', 'deleteByCut', 'deleteByDrag'];
  var lastKeydown = 0;
  document.addEventListener('keydown', function (e) {
    if (searchInput(e.target)) lastKeydown = Date.now();
  }, true);
  document.addEventListener('input', function (e) {
    var input = searchInput(e.target);
    if (!input) return;
    syncValueClass(input);
    if (e.inputType && PASTE_TYPES.indexOf(e.inputType) !== -1) {
      fireKeyup(input);
      return;
    }
    // Vanligt skrivande (även mobiltangentbord och IME) har en keydown precis
    // före och får sin egen keyup. Utan keydown kommer ingen keyup: skicka en.
    // Kommer ändå ingen keyup inom 300 ms (en tangent hålls sällan längre)
    // skickas en för säkerhets skull; en extra keyup är ofarlig eftersom
    // _search väntar 250 ms (debounce) och bara läser fältets värde.
    var at = Date.now();
    if (at - lastKeydown > 50) {
      fireKeyup(input);
      return;
    }
    setTimeout(function () {
      if (lastKeyup < at) fireKeyup(input);
    }, 300);
  }, true);

  /* ---------- 1. Escape behåller texten ---------- */
  var escAt = 0;
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    escAt = Date.now();
    var inputs = allInputs();
    var saved = [];
    for (var i = 0; i < inputs.length; i++) saved.push(inputs[i].value);
    setTimeout(function () {
      for (var j = 0; j < inputs.length; j++) {
        if (saved[j] && inputs[j].value === '') inputs[j].value = saved[j];
        clearTimeout(inputs[j]._nvLsTimer);
        inputs[j]._nvLsStarted = 0;
        syncValueClass(inputs[j]);
      }
    }, 0);
  }, true);

  /* ---------- 4. Fokus i ett ifyllt fält ---------- */
  // Capture på document körs före temats focus.live-search (_searchFocused) på fältet
  document.addEventListener('focus', function (e) {
    var input = searchInput(e.target);
    if (!input) return;
    syncValueClass(input);
    if (!input.value.length) return;
    // _closeEsc flyttar fokus till fältet när rutan stängs: öppna inte igen
    if (Date.now() - escAt < 100) return;
    var box = boxOf(input);
    var results = box.querySelector('[data-live-search-results]');
    var ph = box.querySelector('[data-live-search-placeholder]');
    // "Inga träffar" räknas inte: då visar temat snabblänkarna, som är dolda
    // när fältet har text, och rutan skulle öppnas tom. Sök om i stället.
    var hasResults = results && results.children.length > 0 &&
      !results.querySelector('[data-nv-ls-error]') &&
      !results.querySelector('[data-live-search-no-products]');
    if (hasResults) return;
    if (ph && ph.classList.contains('visible')) return; // en sökning pågår redan
    if (results) results.innerHTML = '';
    if (ph) ph.classList.add('visible');
    var fly = box.querySelector('[data-live-search-flydown]');
    if (fly) fly.style.setProperty('--open-height', 'auto');
    fireKeyup(input);
  }, true);

  /* ---------- 5. Combobox: aria-controls och aria-expanded ---------- */
  // Temat öppnar rutan med klassen live-search--active på [data-live-search]
  var comboSeq = 0;
  function syncExpanded(box, input) {
    input.setAttribute('aria-expanded', box.classList.contains('live-search--active') ? 'true' : 'false');
  }
  function bindCombo(input) {
    if (input._nvCombo) return;
    var box = boxOf(input);
    var fly = box && box.querySelector('[data-live-search-flydown]');
    if (!fly) return;
    input._nvCombo = true;
    if (!fly.id) fly.id = 'nv-ls-flydown-' + (++comboSeq);
    input.setAttribute('aria-controls', fly.id);
    syncExpanded(box, input);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { syncExpanded(box, input); })
        .observe(box, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init() {
    var inputs = allInputs();
    for (var i = 0; i < inputs.length; i++) {
      syncValueClass(inputs[i]);
      bindCombo(inputs[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Webbläsaren kan fylla i fältet igen från bakåt-cachen
  window.addEventListener('pageshow', init);
})();
